import '../../css/frontend/style.css';

// import foo from './components/bar';
